// @flow
import * as React from 'react';

import { Base } from '@gandi/ui';

import styles from './Container.scss';

export type Props = {
  children: React.Node,
  title: string,
};

export function Container({ children, title }: Props): React.MixedElement {
  return (
    <Base className={styles.root}>
      <Base tagName="h2" size="big">
        {title}
      </Base>
      {children}
    </Base>
  );
}
